import store from "./store";
import router from "./router";
import axios from "axios";
import { Message, Notification } from "element-ui";
axios.defaults.baseURL = store.state.baseUrl;
axios.interceptors.request.use((config) => {
  if (localStorage.getItem("token")) {
    config.headers.token = localStorage.getItem("token");
    config.headers.cid = localStorage.getItem("pid");
  }
  return config;
});
axios.defaults.timeout = 500000; // 设置全局超时时间为500秒

axios.interceptors.response.use((res) => {
  if (res.status == 200) {
    const data = res.data;
    // token失效
    if (data.Code == -1 || data.Code == -2) {
      localStorage.clear();
      localStorage.setItem("isLogin", false);
      store.state.isClickProject = false;
      Message.closeAll();
      //token失效直接跳转登录页，无需提醒
      // Message({
      //   showClose: true,
      //   message: data.Message,
      //   type: "error",
      //   duration: 1000,
      // });
      // setTimeout(() => {
      location.href = "/#/login";
      // }, 1000);
    } else if (data.Code == -2) {
      // router.replace({
      //   path: "/enterpriseIndex"
      // });
      location.href = "/#/enterpriseIndex";
    }
    return data;
  } else {
    return res;
  }
});

//#region 2025-10-20后新增
export const AddOrUpdateMyDocumentTree = (params) => {
  return axios.post("/api/AddOrUpdateMyDocumentTree", params);
};
export const GetMyDocumentTree = (params) => {
  return axios.post("/api/GetMyDocumentTree", params);
};
export const UploadMyDocument = (params, config) => {
  return axios.post("/api/UploadMyDocument", params, config);
};

export const UploadProjectDocument = (params, config) => {
  return axios.post("/api/UploadProjectDocument", params, config);
};
export const AddOrUpdateMyDocument = (params, config) => {
  return axios.post("/api/AddOrUpdateMyDocument", params, config);
};
export const GetMyDocument = (params) => {
  return axios.post("/api/GetMyDocument", params);
};
export const transformmydocument = (params) => {
  return axios.post("/api/transformmydocument", params);
};
export const DownLoadMyDocument = (params) => {
  return axios.post("/api/DownLoadMyDocument", params);
};
export const DownLoadProjectDocument = (params) => {
  return axios.post("/api/DownLoadProjectDocument", params);
};
export const DelProjectDocument = (params) => {
  return axios.post("/api/DelProjectDocument", params);
};
export const ShowHideProjectDocument = (params) => {
  return axios.post("/api/ShowHideProjectDocument", params);
};
export const DelMyDocument = (params) => {
  return axios.post("/api/DelMyDocument", params);
};



//#endregion


//#region 接口

// 登录
export const login = (params) => {
  return axios.post("/api/Login", params);
};
//复制计划任务
export const CopyPlan = (params) => {
  return axios.post("/api/CopyPlan", params);
};
// 退出登录
export const outLogin = (params) => {
  return axios.post("/api/ExitUser", params);
};
// 用户列表
export const GetUserList = (params) => {
  return axios.get("/api/GetUserList", params);
};
// 获取用户详情
export const GetUserInfo = (params) => {
  return axios.get("/api/GetUserInfo", params);
};
// 获取用户所属公司
export const GetUserCompanyList = (params) => {
  return axios.get("/api/GetUserCompanyList", params);
};
// 获取个人参与的项目列表
export const GetProjectList = (params) => {
  return axios.get("/api/GetProjectList", params);
};

//  企业列表
export const GetCompanyList = (params) => {
  return axios.get("/api/GetCompanyList", params);
};
// 企业人员列表
export const GetCompnayUsers = (params) => {
  return axios.get("/api/GetCompnayUsers", params);
};
// 添加企业
export const AddCompany = (params) => {
  return axios.post("/api/AddCompany", params);
};
// 上传企业logo
export const UploadLogo = (params) => {
  return axios.post("/api/UploadLogo", params);
};
// 新增员工
export const AddCompanyUser = (params) => {
  return axios.post("/api/AddCompanyUser", params);
};

// 超管——公告管理——公告列表
export const getannouncement = (params) => {
  return axios.get("/api/GetNotices", params);
};
// 超管——公告管理——添加公告
export const Addannouncement = (params) => {
  return axios.post("/api/AddNoice", params);
};
// 超管——公告管理——编辑公告
export const CompilePublicity = (params) => {
  return axios.post("/api/EditNoice", params);
};
// 超管——宣传管理——删除公告
export const Removeannouncement = (params) => {
  return axios.post("/api/DelNotice", params);
};

// 超管——宣传管理——宣传列表
export const Getpublicity = (params) => {
  return axios.get("/api/GetPublicity", params);
};
// 超管——宣传管理——宣传添加
export const Addpublicity = (params) => {
  return axios.post("/api/AddPublicity", params);
};
// 超管——宣传管理——宣传编辑
export const EditPublicity = (params) => {
  return axios.post("/api/EditPublicity", params);
};
// 超管——宣传管理——宣传删除
export const Removepublicity = (params) => {
  return axios.post("/api/DelPublicity", params);
};
// 超管——宣传管理——宣传查找
export const Findpublicity = (params) => {
  return axios.get("/api/FindPublicity", params);
};
// 超管——功能模板管理——获取全部/公司功能模块
export const GetFunctionTemplate = (params) => {
  return axios.get("/api/GetFunctionTemplate", params);
};
// 超管——功能模板管理——添加/修改功能模板
export const AddOrUpdateFunctionTemplate = (params) => {
  return axios.post("/api/AddOrUpdateFunctionTemplate", params);
};
// 超管——功能模板管理——拖拽功能模板
export const DropFunctionTemplate = (params) => {
  return axios.post("/api/DropFunctionTemplate", params);
};
// 超管——功能模板管理——删除功能模块
export const DelFunctionTemplate = (params) => {
  return axios.post("/api/DelFunctionTemplate", params);
};
// 超管——功能模板管理——获取模板列表
export const GetFormTempLists = (params) => {
  return axios.get("/api/GetFormTempList", params);
};
// 超管——功能模板管理——获取单个模板数据
export const GetOneFormTemps = (params) => {
  return axios.get("/api/GetOneFormTemp", params);
};
// 超管——功能模板管理——获取设置完整的表单模板
export const GetFullFormTemps = (params) => {
  return axios.get("/api/GetFullFormTemp", params);
};
// 超管——功能模板管理——添加或更新表单模板
export const AddOrUpdateFormTemps = (params) => {
  return axios.post("/api/AddOrUpdateFormTemp", params);
};
// 超管——功能模板管理——删除单个模板
export const DelOneFormTemps = (params) => {
  return axios.post("/api/DelOneFormTemp", params);
};
// 超管——企业管理——更新企业关联模板
export const UpdateFuncTempLinkCompany = (params) => {
  return axios.post("/api/UpdateFuncTempLinkCompany", params);
};
// 项管——项目立项——添加/更新表单审核流程
export const AddOrUpdateFormAuditFlows = (params) => {
  return axios.post("/api/AddOrUpdateFormAuditFlow", params);
};
// 项管——项目立项——获取表单审核流程列表
export const GetFormAuditFlowLists = (params) => {
  return axios.get("/api/GetFormAuditFlowList", params);
};
// 项管——项目立项——获取单个表单审核流程
export const GetOneFormAuditFlows = (params) => {
  return axios.get("/api/GetOneFormAuditFlow", params);
};
// 项管——项目立项——删除表单审核流程
export const DelFormAuditFlows = (params) => {
  return axios.get("/api/DelFormAuditFlow", params);
};
// 项管——项目立项——拷贝表单审核流程
export const CopyFormAuditFlows = (params) => {
  return axios.get("/api/CopyFormAuditFlow", params);
};

// 获取企业下的部门列表
export const GetProjectDept = (params) => {
  return axios.get("/api/GetProjectDept", params);
};
// 获取部门下得项目
export const GetCompanyProjectList = (params) => {
  return axios.get("/api/GetCompanyProjectList", params);
};
// 查看项目详情
export const GetProjectInfo = (params) => {
  return axios.get("/api/GetProjectInfos", params);
};
// 获取模型列表(根据公司id)
export const GetModelList = (params) => {
  return axios.get("/api/GetModelList", params);
};
// 获取模型列表(根据项目id)
export const GetModelListByXid = (params) => {
  return axios.post("/api/GetModelListByXid", params);
};
// 添加模型
export const AddModelfile = (params) => {
  return axios.post("/api/AddModelfile", params);
};
// 删除模型DelModelFile
export const DelModelFile = (params) => {
  return axios.post("/api/DelModelFile", params);
};

// 用户————个人中心
export const GetPersonalCenter = (params) => {
  return axios.get("/api/GetPersonalCenter", params);
};
// 用户——个人中心——修改用户头像
export const UploadUserImg = (params) => {
  return axios.post("/api/UploadUserImg", params);
};
// 用户——个人中心——修改资料
export const EditPersonalCenter = (params) => {
  return axios.post("/api/EditPersonalCenter", params);
};

// 用户——个人中心——检查账户
export const CheckUserName = (params) => {
  return axios.post("/api/CheckUserName", params);
};

// 用户——个人中心——验证手机邮箱
export const CheckEditUser = (params) => {
  return axios.get("/api/CheckEditUser", params);
};
// 用户————企业人员列表
export const GetCompanyUserList = (params) => {
  return axios.get("/api/GetCompanyUserList", params);
};

// 企业管理
// 获取公司职位
export const GetMyCompnay = (params) => {
  return axios.get("/api/GetMyCompnay", params);
};
// 判断用户再项目中角色
export const GetProjectUserRole = (params) => {
  return axios.get("/api/GetProjectUserRole", params);
};
// 获取我的主页
export const GetMyIndex = (params) => {
  return axios.get("/api/GetMyIndex", params);
};
// 项目平台公告
export const GetNotice = (params) => {
  return axios.get("/api/GetNotice", params);
};
// 获取企业信息
export const GetCompanyinfo = (params) => {
  return axios.get("/api/GetCompanyinfo", params);
};
// 修改企业信息
export const EditCompany = (params) => {
  return axios.post("/api/EditCompany", params);
};
// 设置企管
export const SettingCompanyAdmin = (params) => {
  return axios.get("/api/SettingCompanyAdmin", params);
};
// 取消企管
export const CanelCompanyAdmin = (params) => {
  return axios.get("/api/CanelCompanyAdmin", params);
};
export const GetUserCompanyOpen = (params) => {
  return axios.get("/api/GetUserCompanyOpen", params);
};
// 添加项目
export const AddProject = (params) => {
  return axios.post("/api/AddProject", params);
};
// 获取分类
export const GetProjectGroupList = (params) => {
  return axios.get("/api/GetProjectGroupList", params);
};
// 获取企业下所有人员
export const GetCompanUserList = (params) => {
  return axios.get("/api/GetCompanUserList", params);
};
// 获取分组下得模型列表
export const GetProjectModelList = (params) => {
  return axios.get("/api/GetProjectModelList", params);
};
// 项目中加载模型
export const AddProjectModel = (params) => {
  return axios.post("/api/AddProjectModel", params);
};
// 卸载模型
export const DelProjectMdoel = (params) => {
  return axios.post("/api/DelProjectMdoel", params);
};

// 获取邀请G
export const GetInvite = (params) => {
  return axios.get("/api/GetInvite", params);
};
// 处理邀请
export const HandleInvite = (params) => {
  return axios.post("/api/HandleInvite", params);
};

// 配置人员信息
export const GetDesignUser = (params) => {
  return axios.get("/api/GetDesignUser", params);
};

//项管——添加项目人员
export const AddProjectUser = (params) => {
  return axios.post("/api/AddProjectUser", params);
};
//项管——项目立项——项目信息——获取
export const GetProjectManagement = (params) => {
  return axios.get("/api/GetProjectInfos", params);
};
//项管——项目立项——项目信息——获取
export const GetUsersWithoutMe = (params) => {
  return axios.get("/api/GetUsersWithoutMe", params);
};
//项管——项目立项——项目信息——修改
export const updateProjectManagement = (params) => {
  return axios.post("/api/UpdateProject", params);
};

//项管——项目立项——通知——获取
export const GetProjectNotice = (params) => {
  return axios.get("/api/GetProjectMsg", params);
};
//项管——项目立项——通知——增加
export const AddProjectNotice = (params) => {
  return axios.post("/api/AddProjectMsg", params);
};
//项管——项目立项——通知——修改
export const UpdateProjectNotice = (params) => {
  return axios.post("/api/EditProjectMsg", params);
};
//项管——项目立项——通知——删除
export const RemoveProjectNotice = (params) => {
  return axios.post("/api/DelProjectMsg", params);
};

//项管——项目立项——作业面维护——获取
export const GetWorkPlaneTree = (params) => {
  return axios.get("/api/GetWorkPlaneTree", params);
};
export const GetWorkPlaneZTree = (params) => {
  return axios.get("/api/GetWorkPlaneZTree", params);
};
//项管——项目立项——作业面维护——删除
export const DelPwokPlane = (params) => {
  return axios.post("/api/DelPwokPlane", params);
};
//项管——项目立项——作业面维护——增加——pwok
export const AddPwokPlane = (params) => {
  return axios.post("/api/AddPwokPlane", params);
};
//项管——项目立项——作业面维护——查看
export const ExamineProjectJob = (params) => {
  return axios.get("/api/FindPworkPlane", params);
};
//项管——项目立项——作业面维护——修改——pwok
export const EditPworkPlane = (params) => {
  return axios.post("/api/EditPworkPlane", params);
};
//修改作业面名字
export const EditPworkPlaneName = (params) => {
  return axios.post("/api/EditPworkPlaneName", params);
};
//项管——团队配置——组织机构——获取
export const GetteamOrganization = (params) => {
  return axios.get("/api/GetProjectdeptTree", params);
};
//项管——团队配置——组织机构——获取 ztree
export const GetProjectdeptZTree = (params) => {
  return axios.get("/api/GetProjectdeptZTree", params);
};

export const GetteamOrganizationList = (params) => {
  return axios.get("/api/GetProjectdeptList", params);
};

//项管——团队配置——组织机构——查看人员
export const GetteamMember = (params) => {
  return axios.get("/api/FinfdProdept", params);
};
//项管——团队配置——组织机构——查看id
export const GetteamMemberUser = (params) => {
  return axios.get("/api/FindProdeptInfo", params);
};
//项管——团队配置——组织机构——编辑——prodept
export const EditProdept = (params) => {
  return axios.post("/api/EditProdept", params);
};
//项管——团队配置——组织机构——新增——prodept
export const Addteam = (params) => {
  return axios.post("/api/AddProjectdept", params);
};
//项管——团队配置——组织机构——删除
export const DelProdept = (params) => {
  return axios.post("/api/DelProdept", params);
};

//项管——团队配置——成员管理——获取
export const GetMember = (params) => {
  return axios.get("/api/GetProUsersList", params);
};
//项管——团队配置——成员管理——删除
export const RemoveMember = (params) => {
  return axios.post("/api/DelProUsers", params);
};
//项管——团队配置——成员管理——编辑——
export const UpdateMember = (params) => {
  return axios.post("/api/EditProUsers", params);
};

//项管——团队配置——岗位权限——获取——id
export const GetObesity = (params) => {
  return axios.get("/api/GetPost", params);
};
//项管——团队配置——岗位权限——删除岗位标题——id
export const RemoveObesity = (params) => {
  return axios.post("/api/DelPost", params);
};
//项管——团队配置——岗位权限——新增岗位标题——addpror
export const AddObesity = (params) => {
  return axios.post("/api/AddPost", params);
};
//项管——团队配置——岗位权限——删除岗位下的人员信息——uid
export const RemoveObesityUser = (params) => {
  return axios.post("/api/DelPostUser", params);
};
//项管——团队配置——岗位权限——编辑——comuser
export const UpdateObesity = (params) => {
  return axios.post("/api/EditPost", params);
};
//项管——团队配置——岗位权限列表——选择——xid
export const GetProjectRole = (params) => {
  return axios.post("/api/GetProjectRole", params);
};
//项管——团队配置——岗位权限配置——配置——
export const RoleSetting = (params) => {
  return axios.post("/api/RoleSetting", params);
};

//项管——协作配置——工单设置——获取——id
export const GetLabel = (params) => {
  return axios.get("/api/GetWorkOrderSetList", params);
};
//项管——协作配置——工单设置——删除——id
export const RemoveLabel = (params) => {
  return axios.post("/api/DelWorkOrderSet", params);
};
//项管——协作配置——工单设置——编辑——workorder
export const UpdateLabel = (params) => {
  return axios.post("/api/EditWorkOrder", params);
};
//项管——协作配置——工单设置——添加——workorder
export const AddLabel = (params) => {
  return axios.post("/api/AddWorkOrder", params);
};

//项管——综合管理设置——设计协调配置——获取——xid
export const GetLabelList = (params) => {
  return axios.get("/api/GetLablesetList", params);
};
//项管——综合管理设置——设计协调配置——增加——model
export const AddLabelList = (params) => {
  return axios.post("/api/AddLableset", params);
};
//项管——综合管理设置——设计协调配置——删除——id
export const RemoveLabelListss = (params) => {
  return axios.post("/api/DelLableset", params);
};
//项管——综合管理设置——设计协调配置——编辑——model
export const UpdateLabelListss = (params) => {
  return axios.post("/api/EditLableset", params);
};
//项管——综合管理设置——设计协调配置——审批流程——model
export const ExamineLabelListss = (params) => {
  return axios.post("/api/AddApproval", params);
};

// 项管——条码管理设置——模板设置——获取列表
export const GetTempsetList = (params) => {
  return axios.get("/api/GetTempsetList", params);
};
// 项管——条码管理设置——模板设置——添加模板设置详情
export const AddTempset = (params) => {
  return axios.post("/api/AddTempset", params);
};
// 项管——条码管理设置——模板设置——删除模板设置
export const DelTempset = (params) => {
  return axios.post("/api/DelTempset", params);
};
// 项管——条码管理设置——模板设置——获取模板详情
export const GetTempSetInfo = (params) => {
  return axios.get("/api/GetTempSetInfo", params);
};
// 项管——条码管理设置——模板设置——编辑模板信息
export const EditTempInfo = (params) => {
  return axios.post("/api/EditTempInfo", params);
};
// 项管——条码管理设置——模板设置——编辑字段
export const EditTempsetLink = (params) => {
  return axios.post("/api/EditTempsetLink", params);
};
// 项管——条码管理设置——模板设置——添加字段
export const AddTempsetLink = (params) => {
  return axios.post("/api/AddTempsetLink", params);
};
// 项管——条码管理设置——模板设置——删除字段
export const DelTempsetLink = (params) => {
  return axios.post("/api/DelTempsetLink", params);
};

//测试----id
export const ceshi = (params) => {
  return axios.post("/api/GetUserInfo", params);
};

//项目设置——团队成员——通讯目录——获取左侧信息——id
export const GetTeam = (params) => {
  return axios.get("/api/GetProjectDeptTree", params);
};
//项目设置——团队成员——通讯目录——获取右侧信息——xid
export const GetDeptUser = (params) => {
  return axios.get("/api/GetDeptUser", params);
};

// 企管——项目管理——修改信息
export const UpdateProjectManager = (params) => {
  return axios.post("/api/UpdateProjectManager", params);
};
// 企管——人员管理——获取——seachword
export const AddCorporateGovernanceRen = (params) => {
  return axios.get("/api/GetCompanUserList", params);
};

// 企管——人员管理——开关——uid
export const SwitchsCorporateGovernance = (params) => {
  return axios.post("/api/DisableUser", params);
};

// 企管——人员管理——所属部门列表——qid
export const GetCorporateGovernanceDepartment = (params) => {
  return axios.get("/api/GetCompanyDeptList", params);
};

// 企管——人员管理——所属部门修改——
export const UpdateCorporateGovernanceDepartment = (params) => {
  return axios.post("/api/UpdateUserDept", params);
};
// 企管——人员管理——人员职位修改——uid
export const UpdateCorporateGovernancePosition = (params) => {
  return axios.post("/api/UpdateUserJob", params);
};
// 企管——人员管理——邀请用户——model
export const InviteCorporateGovernanceUser = (params) => {
  return axios.post("/api/InviteUsers", params);
};
// 企管——人员管理——删除用户——uid-id
export const RemoveCorporateGovernanceUser = (params) => {
  return axios.post("/api/DelProjectUser", params);
};

// 项目主页——企业光荣榜
export const GetCompanyNBUser = (params) => {
  return axios.get("/api/GetCompanyNBUser", params);
};
// 项目主页——待办任务
export const GetTaskTodo = (params) => {
  return axios.get("/api/GetTaskTodo", params);
};
// 项目主页——资料动态
export const GetCiY = (params) => {
  return axios.post("/api/GetCiY", params);
};

// 修改企业下的部门
export const EditCompanyDept = (params) => {
  return axios.post("/api/EditCompanyDept", params);
};
// 查看部门详请
export const FindCompanyDept = (params) => {
  return axios.get("/api/FindCompanyDept", params);
};
// 删除部门
export const DelCompanyDept = (params) => {
  return axios.post("/api/DelCompanyDept", params);
};
// 新增部门
export const AddCompanyDept = (params) => {
  return axios.post("/api/AddCompanyDept", params);
};
//部门排序
export const ChangeCompanyDeptOrder = (params) => {
  return axios.post("/api/ChangeCompanyDeptOrder", params);
};
// 获取分类树
export const GetProjectgroupTree = (params) => {
  return axios.get("/api/GetProjectgroupTree", params);
};
// 添加分组
export const AddProjectgroup = (params) => {
  return axios.post("/api/AddProjectgroup", params);
};
//分组排序
export const ChangeProjectGroupOrder = (params) => {
  return axios.post("/api/ChangeProjectGroupOrder", params);
};
// 查看分组
export const FindProjectgroup = (params) => {
  return axios.get("/api/FindProjectgroup", params);
};
// 编辑分组
export const EditProjectgroup = (params) => {
  return axios.post("/api/EditProjectgroup", params);
};
// 删除分组
export const DelProjectgroup = (params) => {
  return axios.post("/api/DelProjectgroup", params);
};

// 获取设计协调列表
export const GetDesigncdnationList = (params) => {
  return axios.get("/api/GetDesigncdnationList", params);
};
// 添加审批流程
export const AddAuditUser = (params) => {
  return axios.post("/api/AddAuditUser", params);
};
// 添加抄送流程
export const AddCCUser = (params) => {
  return axios.post("/api/AddCCUser", params);
};
// 获取未加入配置得人员
export const GetAuditUserList = (params) => {
  return axios.get("/api/GetAuditUserList", params);
};
// 修改或签会签
export const UpdatePworkFlow = (params) => {
  return axios.post("/api/UpdatePworkFlow", params);
};
// 获取标签GetLablesetListOpen
export const GetLablesetListOpen = (params) => {
  return axios.get("/api/GetLablesetListOpen", params);
};
// 获取模型下的选择集
export const GetModelSelect = (params) => {
  return axios.get("/api/GetModelSelect", params);
};

// 获取文件列表
export const GetFilesLinks = (params) => {
  return axios.get("/api/GetFilesLinks", params);
};
//获取单个作业面信息
export const FindPworkPlane = (params) => {
  return axios.get("/api/FindPworkPlane", params);
};
// 获取设计协调信息
export const GetDesigncdnation = (params) => {
  return axios.get("/api/GetDesigncdnation", params);
};
//作业面排序
export const ChangePworkPlaneOrder = (params) => {
  return axios.post("/api/ChangePworkPlaneOrder", params);
};
// 设计协调审批
export const HandeApproval = (params) => {
  return axios.post("/api/HandeApproval", params);
};

// 新增资料目录————pfiletree
export const AddProjectFile = (params) => {
  return axios.post("/api/AddProjectFile", params);
};
// 获取资料目录
export const GetProjectFileTree = (params) => {
  return axios.get("/api/GetProjectFileTree", params);
};
export const GetProjectFileZTree = (params) => {
  return axios.get("/api/GetProjectFileZTree", params);
};
// 编辑资料目录
export const EditProjectFile = (params) => {
  return axios.post("/api/EditProjectFile", params);
};
// 查找资料目录
export const FindProjectFileInfo = (params) => {
  return axios.post("/api/FindProjectFileInfo", params);
};
// 更改目录排序
export const ChangeProjectFileOrder = (params) => {
  return axios.post("/api/ChangeProjectFileOrder", params);
};
// 用户————工程联系单————工程联系单
export const GetPcontactorderList = (params) => {
  return axios.get("/api/GetPcontactorderList", params);
};
// 用户————工程联系单————新增联系单
export const AddPcontactorder = (params) => {
  return axios.post("/api/AddPcontactorder", params);
};
// 用户————工程联系单————上传项目
export const UploadProjectFile = (params) => {
  return axios.post("/api/UploadProjectFile", params);
};
// 用户————工程联系单————审批工程联系单
export const HandeApprovals = (params) => {
  return axios.post("/api/HandeApprovals", params);
};
// 用户————工程联系单————工程联系单详情
export const GetPcontactorderInfo = (params) => {
  return axios.get("/api/GetPcontactorderInfo", params);
};

// 用户————工单任务————启动/申请审核
export const UpdateWorkOrderTime = (params) => {
  return axios.post("/api/UpdateWorkOrderTime", params);
};
// 用户————工单任务————进度或审核
export const HandelWorkOrder = (params) => {
  return axios.post("/api/HandelWorkOrder", params);
};

// 用户————工单任务————阅读催办
export const ReadWorkOrder = (params) => {
  return axios.get("/api/ReadWorkOrder", params);
};

// 用户————工单任务————催办
export const AddWorkOrderMsg = (params) => {
  return axios.post("/api/AddWorkOrderMsg", params);
};
// 用户————工单任务————获取所有工单
export const GetWorkOrderList = (params) => {
  return axios.get("/api/GetWorkOrderList", params);
};
// 用户————工单任务————获取工单标签
export const GetWorkOrderSet = (params) => {
  return axios.get("/api/GetWorkOrderSet", params);
};
// 用户————工单任务————发起工单
export const AddWorkOrderUser = (params) => {
  return axios.post("/api/AddWorkOrderUser", params);
};
// 用户————工单任务————删除工单
export const DelWorkOrder = (params) => {
  return axios.post("/api/DelWorkOrder", params);
};

// 用户————工单任务————获取审核人员
export const GetAuditUserList2 = (params) => {
  return axios.post("/api/GetAuditUserList2", params);
};
// 用户————工单任务————获取成员管理列表
export const GetProUsersList = (params) => {
  return axios.get("/api/GetProUsersList", params);
};
// 用户————工单任务————工单信息
export const GetWorkOrderInfo = (params) => {
  return axios.get("/api/GetWorkOrderInfo", params);
};

// 用户————安全交底————获取列表
export const GetProjectSafeList = (params) => {
  return axios.get("/api/GetProjectSafeList", params);
};
// 用户————安全交底————新增
export const AddProjectSafe = (params) => {
  return axios.post("/api/AddProjectSafe", params);
};
// 用户————安全交底————状态
export const GetProjectSafeInfo = (params) => {
  return axios.get("/api/GetProjectSafeInfo", params);
};
export const HandelSafe = (params) => {
  return axios.post("/api/HandelSafe", params);
};
// 用户————施工交底————获取列表
export const GetProjectWorkListss = (params) => {
  return axios.get("/api/GetProjectWorkList", params);
};
// 用户————施工交底————新增
export const AddProjectWorks = (params) => {
  return axios.post("/api/AddProjectWork", params);
};
// 用户————施工交底————审批
export const HandelWork = (params) => {
  return axios.post("/api/HandelWork", params);
};
// 用户————施工交底————审批流程状态
export const GetProjectWorkInfo = (params) => {
  return axios.get("/api/GetProjectWorkInfo", params);
};

// 用户————设计协调————新增
export const AddDesigncdnation = (params) => {
  return axios.post("/api/AddDesigncdnation", params);
};

// 用户————实景列表————获取列表
export const GetModelLabelSetList = (params) => {
  return axios.get("/api/GetModelLabelSetList", params);
};
// 用户————实景列表————删除实景列表
export const DelModelLabelSet = (params) => {
  return axios.post("/api/DelModelLabelSet", params);
};
// 用户————实景列表————添加实景
export const UploadModelLable = (params) => {
  return axios.post("/api/UploadModelLable", params);
};

// 用户——条码管理——条码列表——获取列表
export const GetBarCodeList = (params) => {
  return axios.get("/api/GetBarCodeList", params);
};
// 用户——条码管理——条码列表——信息
export const GetBarCodeInfo = (params) => {
  return axios.get("/api/GetBarCodeInfo", params);
};
// 用户——条码管理——条码列表——模板
export const GetTemplList = (params) => {
  return axios.get("/api/GetTemplList", params);
};
// 用户——条码管理——条码列表——打印次数
export const AddPrintCount = (params) => {
  return axios.post("/api/AddPrintCount", params);
};

// 用户 资料管理
// 资料列表
export const GetDataFileList = (params) => {
  return axios.get("/api/GetDataFileList", params);
};
// 删除资料
export const DelDataFile = (params) => {
  return axios.post("/api/DelDataFile", params);
};
// 分享管理
export const GetShareDataFileList = (params) => {
  return axios.get("/api/GetShareDataFileList", params);
};
// 取消分享
export const DelFileLink = (params) => {
  return axios.post("/api/DelFileLink", params);
};
// 分享文件
export const ShareFile = (params) => {
  return axios.post("/api/ShareFile", params);
};
// 收藏文件
export const CollectionFile = (params) => {
  return axios.post("/api/CollectionFile", params);
};
// 移动文件
export const MoveFile = (params) => {
  return axios.post("/api/MoveFile", params);
};
// 添加资料关联人
export const AddFileUser = (params) => {
  return axios.post("/api/AddFileUser", params);
};
// 更改公开半公开
export const ChangeFileState = (params) => {
  return axios.post("/api/ChangeFileState", params);
};

// 获取未参与这个资料的人
export const GetFileWhitOutUserList = (params) => {
  return axios.get("/api/GetFileWhitOutUserList", params);
};
// 获取一参加这个资料的人
export const GetFileWhitUserList = (params) => {
  return axios.get("/api/GetFileWhitUserList", params);
};
// 删除资料关联人
export const DelFileWhitUser = (params) => {
  return axios.post("/api/DelFileWhitUser", params);
};
/*取消收藏 */
export const DelCollectFile = (params) => {
  return axios.post("/api/DelCollectFile", params);
};
// 获取实景标签GetModelLableSets
export const GetModelLableSets = (params) => {
  return axios.get("/api/GetModelLableSets", params);
};

// 查找作业面模型
export const FindWorkPlaneModel = (params) => {
  return axios.post("/api/FindWorkPlaneModel", params);
};
// 查找作业面模型(列表)
export const GetWorkPlaneLinkModes = (params) => {
  return axios.post("/api/GetWorkPlaneLinkModes", params);
};
// 删除资料目录
export const DelProjectFile = (params) => {
  return axios.post("/api/DelProjectFile", params);
};
///获取施工交底列表
export const GetProjectWorkList = (params) => {
  return axios.get("/api/GetProjectWorkList", params);
};
//添加施工交底
export const AddProjectWork = (params) => {
  return axios.post("/api/AddProjectWork", params);
};

// GetModelLableList(int xid,int modelId,int type,string searchword,int pageIndex,  int pageSize)

// 获取实景点位列表GetModelLableList
export const GetModelLableList = (params) => {
  return axios.post("/api/GetModelLableList", params);
};

// 根据文档获取选择集
export const GetFileLinkSelect = (params) => {
  return axios.post("/api/GetFileLinkSelect", params);
};
// 根据选择集获取文档
export const GetSelectLinkFile = (params) => {
  return axios.post("/api/GetSelectLinkFile", params);
};
// 获取模型条码点位
export const GetModelBarCodeList = (params) => {
  return axios.post("/api/GetModelBarCodeList", params);
};
// 条码点位获取dbids
export const GetModelBarCodeDbids = (params) => {
  return axios.post("/api/GetModelBarCodeDbids", params);
};
// 获取单个模型信息
export const GetModelInfo = (params) => {
  return axios.post("/api/GetModelInfo", params);
};
// 获取多个模型信息
export const GetModelInfos = (params) => {
  return axios.post("/api/GetModelInfos", params);
};
// 修改项目分组
export const UpdateProjectGroup = (params) => {
  return axios.post("/api/UpdateProjectGroup", params);
};
// 启用禁用Publicity
export const EnablePublicity = (params) => {
  return axios.post("/api/EnablePublicity", params);
};
// 登录首页获取宣传公告
export const IndexPublicity = (params) => {
  return axios.post("/api/IndexPublicity", params);
};
// 增加主页宣传公告点击量
export const AddPublicityClicks = (params) => {
  return axios.post("/api/AddPublicityClicks", params);
};

// 获取话题讨论列表  GetTopicList(int modelId, int xid, int lableId, int userid)
export const GetTopicList = (params) => {
  return axios.post("/api/GetTopicList", params);
};
// 获取话题讨论创建人列表 GetTopicUserList(int xid,int modelId)
export const GetTopicUserList = (params) => {
  return axios.post("/api/GetTopicUserList", params);
};
// 获取话题讨论标签 GetTopicContent(int id)
export const GetTopicContent = (params) => {
  return axios.post("/api/GetTopicContent", params);
};
// 删除话题讨论 DelTopic(int id)
export const DelTopic = (params) => {
  return axios.post("/api/DelTopic", params);
};
// 添加话题讨论内容 AddTopicContent(eab_topiclink model)
export const AddTopicContent = (params) => {
  return axios.post("/api/AddTopicContent", params);
};
// 添加话题讨论 AddTopic(eab_projecttopic model)
export const AddTopic = (params) => {
  return axios.post("/api/AddTopic", params);
};

// 获取话题标签列表
export const GetptopicsetList = (params) => {
  return axios.get("/api/GetptopicsetList", params);
};
// 上传话题标签
export const Addptopicset = (params) => {
  return axios.post("/api/Addptopicset", params);
};
// 删除话题标签
export const Delptopicset = (params) => {
  return axios.post("/api/Delptopicset", params);
};

// 编辑话题标签
export const UpdatePtopicset = (params) => {
  return axios.post("/api/UpdatePtopicset", params);
};
// 获取项目日程安排  GetSchedule(int xid, string date, int userid)
export const GetSchedule = (params) => {
  return axios.post("/api/GetSchedule", params);
};
//更新日程安排  UpdateSchedule(int id, int state)
export const UpdateSchedule = (params) => {
  return axios.post("/api/UpdateSchedule", params);
};
//添加日程 AddSchedule(eab_calendar model)
export const AddSchedule = (params) => {
  return axios.post("/api/AddSchedule", params);
};
//删除日程 DelSchedule(int id)
export const DelSchedule = (params) => {
  return axios.post("/api/DelSchedule", params);
};

// 获取项目人员（进度计划）
export const GetPlanUser = (params) => {
  return axios.post("/api/GetPlanUser", params);
};
// 添加/更新项目计划
export const UpdatePlan = (params) => {
  return axios.post("/api/UpdatePlan", params);
};
// 获取项目进度计划
export const GetPlanList = (params) => {
  return axios.post("/api/GetPlanList", params);
};
// 获取单个项目进度计划
export const GetPlanOne = (params) => {
  return axios.post("/api/GetPlanOne", params);
};

// 删除进度计划人员
export const DelPlanUser = (params) => {
  return axios.post("/api/DelPlanUser", params);
};
// 添加进度计划特定人员
export const AddPlanUser = (params) => {
  return axios.post("/api/AddPlanUser", params);
};
// 获取进度计划节点管理
export const GetPlanNode = (params) => {
  return axios.post("/api/GetPlanNode", params);
};
// 进度任务详情树
export const GetPlanDetailTree = (params) => {
  return axios.get("/api/GetPlanDetailTree", params);
};

// 添加/更新项目计划节点
export const UpdatePlanNode = (params) => {
  return axios.post("/api/UpdatePlanNode", params);
};
//  更新项目计划节点详情
export const UpdatePlanDetail = (params) => {
  return axios.post("/api/UpdatePlanDetail", params);
};
// 添加模型关联/文档关联
export const AddPlanSelectOrDocument = (params) => {
  return axios.post("/api/AddPlanSelectOrDocument", params);
};
// 删除模型关联/文档关联
export const DelPlanSelectOrDocument = (params) => {
  return axios.post("/api/DelPlanSelectOrDocument", params);
};
// 获取单个进度计划详情
export const GetPlanDetailOne = (params) => {
  return axios.post("/api/GetPlanDetailOne", params);
};
// 添加进度计划记录

export const AddRecord = (params) => {
  return axios.post("/api/AddRecord", params);
};

// 删除进度计划
export const DelPlan = (params) => {
  return axios.post("/api/DelPlan", params);
};
// 获取三维模型数据
export const Get3DSimulate = (params) => {
  return axios.post("/api/Get3DSimulate", params);
};
// 获取项目进度计划（不带进度）
export const GetPlanListNoJd = (params) => {
  return axios.post("/api/GetPlanListNoJd", params);
};

// 获取进度记录
export const GetRecordList = (params) => {
  return axios.post("/api/GetRecordList", params);
};

// 超管强制下线功能
export const QuitUser = (params) => {
  return axios.post("/api/QuitUser", params);
};

// 查看单个公告
export const FindNotice = (params) => {
  return axios.get("/api/FindNotice", params);
};

// 删除流程
export const delAtta = (params) => {
  return axios.post("/api/delAtta", params);
};
// 删除抄送流程
export const delAttaUser = (params) => {
  return axios.post("/api/delAttaUser", params);
};
// 企管删除用户
export const delCompanyUser = (params) => {
  return axios.post("/api/delCompanyUser", params);
};

// 获取角色列表
export const GetRoleList = (params) => {
  return axios.post("/api/GetRoleList", params);
};

// 模型按钮
export const GetWorkPlaneTree2 = (params) => {
  return axios.post("/api/GetWorkPlaneTree2", params);
};

// 删除设计协调
export const DelDesigncdnation = (params) => {
  return axios.post("/api/DelDesigncdnation", params);
};
// 删除安全交底
export const DelProjectSafe = (params) => {
  return axios.post("/api/DelProjectSafe", params);
};
// 删除施工交底
export const DelProjectWork = (params) => {
  return axios.post("/api/DelProjectWork", params);
};
// 删除工程联系单
export const DelPcontact = (params) => {
  return axios.post("/api/DelPcontact", params);
};
// 更新项目人员
export const UpdateProUser = (params) => {
  return axios.post("/api/UpdateProUser", params);
};

// 查找项目成员
export const FindProUser = (params) => {
  return axios.post("/api/FindProUser", params);
};
// 获取组织机构列表
export const GetProjectdeptList = (params) => {
  return axios.get("/api/GetProjectdeptList", params);
};

// 查找角色权限
export const findRoleRight = (params) => {
  return axios.post("/api/findRoleRight", params);
};
// 更新角色权限
export const updateRoleRight = (params) => {
  return axios.post("/api/updateRoleRight", params);
};

// 更新平台公告阅读量
export const AddNoiceReads = (params) => {
  return axios.post("/api/AddNoiceReads", params);
};

// 超管端修改密码
export const AdminUpdatePwd = (params) => {
  return axios.post("/api/AdminUpdatePwd", params);
};

// 获取视点或选择集
export const GetModelSelectOrViewPoint = (params) => {
  return axios.post("/api/GetModelSelectOrViewPoint", params);
};

//获取单个视点/选择集
export const GetSelectOrView = (params) => {
  return axios.post("/api/GetSelectOrView", params);
};

// 批量导入计划节点（文件导入）
export const insertExcelPlanNode = (params) => {
  return axios.post("/api/insertExcelPlanNode", params);
};

// 获取示例文件
export const getFile = (params) => {
  return axios.post("/api/UploadFiles/进度计划示例表格.xlsx", params);
};

// 微信解除绑定
export const UnbindWeChat = (params) => {
  return axios.post("/api/UnbindWeChat", params);
};

// 微信登录
export const WeChatLogin = (params) => {
  return axios.post("/api/WeChatLogin", params);
};

// 微信绑定
export const BindWeChat = (params) => {
  return axios.post("/api/BindWeChat", params);
};

// 编辑模型
export const UpdateModelFile = (params) => {
  return axios.post("/api/UpdateModelFile", params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

//获取项目实景标签设置
export const GetMLableSetList = (params) => {
  return axios.post("/api/GetMLableSetList", params);
};

// 获取ZTree项目树 enterpriseProject
export const GetProjectgroupZTree = (params) => {
  return axios.post("/api/GetProjectgroupZTree", params);
};
//下载模型
export const DownModel = (params) => {
  return axios.post("/api/DownModel", params);
};

// 模型关联项目
export const GetModelLinkProjectList = (params) => {
  return axios.post("/api/GetModelLinkProjectList", params);
};

// 获取历史版本
export const GetModelVersionsList = (params) => {
  return axios.post("/api/GetModelVersionsList", params);
};

// 复制模型
export const CopyModel = (params) => {
  return axios.post("/api/CopyModel", params);
};

// 删除历史版本Model
export const DelModelfileVersion = (params) => {
  return axios.post("/api/DelModelfileVersion", params);
};
// GetBigData  大数据
export const GetBigData = (params) => {
  return axios.post("/api/GetBigData", params);
};

// 职位列表
export const GetCompanyTitel = (params) => {
  return axios.get("/api/GetCompanyTitel", params);
};
// 添加职位
export const AddCompanyTitle = (params) => {
  return axios.post("/api/AddCompanyTitle", params);
};
// 删除职位
export const DelCompnayTitel = (params) => {
  return axios.post("/api/DelCompnayTitel", params);
};

//  添加模型选择集
export const AddModelLink = (params) => {
  return axios.post("/api/AddModelLink", params);
};

//删除模型选择集关联
export const DelModelLink = (params) => {
  return axios.post("/api/DelModelLink", params);
};

// 添加资料
export const AddWorkFileLink = (params) => {
  return axios.post("/api/AddWorkFileLink", params);
};

// 删除资料
export const DelWorkFileLink = (params) => {
  return axios.post("/api/DelWorkFileLink", params);
};

// 修改工单任务
export const UpdateWorkOrderAll = (params) => {
  return axios.post("/api/UpdateWorkOrderAll", params);
};

// 是否企管
export const IsEnterprise = (params) => {
  return axios.post("/api/IsEnterprise", params);
};
// 是否超管
export const IsAdmin = (params) => {
  return axios.post("/api/IsAdmin", params);
};
// 是否项管
export const IsProject = (params) => {
  return axios.post("/api/IsProject", params);
};

// 删除条码
export const DelCodeBars = (params) => {
  return axios.post("/api/DelCodeBars", params);
};

// 获取超管平台设置
export const GetadminsetList = (params) => {
  return axios.get("/api/GetadminsetList", params);
};
// 更新平台设置   简称title 名称name  备案text
export const Updateadminset = (params) => {
  return axios.post("/api/Updateadminset", params);
};
// 更新平台设置
export const UpdateOrAddAdminSet = (params) => {
  return axios.post("/api/UpdateOrAddAdminSet", params);
}; // 重置平台设置
export const ResetAdminSet = (params) => {
  return axios.post("/api/ResetAdminSet", params);
};

// 添加/更新 项目动态标签
export const AddOrUpdatePweiboSet = (params) => {
  return axios.post("/api/AddOrUpdatePweiboSet", params);
};

// 获取项目动态标签列表
export const GetPweiboSetList = (params) => {
  return axios.post("/api/GetPweiboSetList", params);
};

// 删除项目动态标签
export const DelPweiboSet = (params) => {
  return axios.post("/api/DelPweiboSet", params);
};

// 获取项目组织并带人员
export const GetDeptWithUser = (params) => {
  return axios.post("/api/GetDeptWithUser", params);
};

//获取动态内容
export const GetProweiboList = (params) => {
  return axios.post("/api/GetProweiboList", params);
};

// 删除个人发布的动态
export const DelWeiBo = (params) => {
  return axios.post("/api/DelWeiBo", params);
};

// 添加动态
export const AddWeiBo = (params) => {
  return axios.post("/api/AddWeiBo", params);
};

// 跟新实景
export const UpdateModelLable = (params) => {
  return axios.post("/api/UpdateModelLable", params);
};
// 新增图纸树节点
export const AddDrwaingTree = (params) => {
  return axios.post("/api/AddDrwaingTree", params);
};
//  删除图纸树
export const DelDrwaingTree = (params) => {
  return axios.post("/api/DelDrwaingTree", params);
};
// 编辑图纸树
export const EditDrwaingTree = (params) => {
  return axios.post("/api/EditDrwaingTree", params);
};
//图纸树
export const Getpdrwaingtree = (params) => {
  return axios.get("/api/Getpdrwaingtree", params);
};
//移动图纸节点
export const ChangeDrwaingTree = (params) => {
  return axios.post("/api/ChangeDrwaingTree", params);
};
//图纸树详情
export const FindDrawingInfo = (params) => {
  return axios.get("/api/FindDrawingInfo", params);
};
//图纸列表
export const GetDrwingFileList = (params) => {
  return axios.get("/api/GetDrwingFileList", params);
};
//删除图纸
export const DelDrwingFile = (params) => {
  return axios.post("/api/DelDrwingFile", params);
};
//分享管理列表
export const GetShareDrawingList = (params) => {
  return axios.get("/api/GetShareDrawingList", params);
};
//分享图纸
export const ShareDrawing = (params) => {
  return axios.post("/api/ShareDrawing", params);
};

//取消分享图纸
export const DelDrawingLink = (params) => {
  return axios.post("/api/DelDrawingLink", params);
};
//收藏图纸
export const CollectionDrawing = (params) => {
  return axios.post("/api/CollectionDrawing", params);
};

//取消收藏图纸
export const DelCollectDrawing = (params) => {
  return axios.post("/api/DelCollectDrawing", params);
};
//修改状态图纸
export const ChangeDrawingState = (params) => {
  return axios.post("/api/ChangeDrawingState", params);
};

//图纸参与人员
export const GetDrawingWhitUserList = (params) => {
  return axios.get("/api/GetDrawingWhitUserList", params);
};
//图纸未参与人员
export const GetDrawingWhitOutUserList = (params) => {
  return axios.get("/api/GetDrawingWhitOutUserList", params);
};
//删除图纸参与人员
export const DelDrawingWhitUser = (params) => {
  return axios.post("/api/DelDrawingWhitUser", params);
};
//删除图纸参与人员
export const AddDrawingUser = (params) => {
  return axios.post("/api/AddDrawingUser", params);
};
// 修改岗位名称
export const EditProjectRoleName = (params) => {
  return axios.post("/api/EditProjectRoleName", params);
};

// 查看图纸
export const ViewDrawings = (params) => {
  return axios.post("/api/ViewDrawings", params);
};
// 转换图纸
export const TransformDrawings = (params) => {
  return axios.post("/api/TransformDrawings", params);
};
//  根据模型ID获取构件属性
export const GetModelPropertyByModeId = (params) => {
  return axios.post("/api/GetModelPropertyByModeId", params);
};
//根据属性查找dbids
export const FindModelProperty = (params) => {
  return axios.post("/api/FindModelProperty", params);
};
// 更新职位
export const UpdateCompanyTitle = (params) => {
  return axios.post("/api/UpdateCompanyTitle", params);
};
// 项目组织排序
export const ChangeProjectDeptOrder = (params) => {
  return axios.post("/api/ChangeProjectDeptOrder", params);
};

// 删除公司
export const DelCompany = (params) => {
  return axios.post("/api/DelCompany", params);
};

// 登录日志
export const GetLoginRecordList = (params) => {
  return axios.get("/api/GetLoginRecordList", params);
};

// 删除登录日志
export const DelLoginRecord = (params) => {
  return axios.post("/api/DelLoginRecord", params);
};

// 操作日志列表
export const GetoperationRecordList = (params) => {
  return axios.get("/api/GetoperationRecordList", params);
};

// 删除操作日志
export const DeloperationRecord = (params) => {
  return axios.post("/api/DeloperationRecord", params);
};

// 添加修改计划
export const AddOrUpdateZjwjProjectPlan = (params) => {
  return axios.post("/api/AddOrUpdateZjwjProjectPlan", params);
};
// 获取项目计划

export const GetZjwjProjectPlan = (params) => {
  return axios.get("/api/GetZjwjProjectPlan", params);
};
// 获取单个项目计划
export const GetZjwjOneProjectPlan = (params) => {
  return axios.get("/api/GetZjwjOneProjectPlan", params);
};
//  zjwj添加/更新项目计划节点
export const UpdateZjwjPlanNode = (params) => {
  return axios.post("/api/UpdateZjwjPlanNode", params);
};
export const UpdateZjwjPlanNodeNew = (params) => {
  return axios.post("/api/UpdateZjwjPlanNodeNew", params);
};
// 获取计划下计划任务
export const GetZjwjPlanDetail = (params) => {
  return axios.get("/api/GetZjwjPlanDetail", params);
};
// 获取单个任务信息
export const GetZjwjOnePlanDetail = (params) => {
  return axios.get("/api/GetZjwjOnePlanDetail", params);
};
// 更新单个任务信息
export const UpdateZjwjOnePlanDetail = (params) => {
  return axios.post("/api/UpdateZjwjOnePlanDetail", params);
};
// 我的任务
export const ZjwjMyToDo = (params) => {
  return axios.get("/api/ZjwjMyToDo", params);
};
// 我的评审
export const ZjwjMyToAudit = (params) => {
  return axios.get("/api/ZjwjMyToAudit", params);
};
// 启动计划
export const ZjwjStartPlan = (params) => {
  return axios.post("/api/ZjwjStartPlan", params);
};

// 添加进度记录
export const AddZjwjPlanRecord = (params) => {
  return axios.post("/api/AddZjwjPlanRecord", params);
};

// 获取进度记录
export const GetZjwjPlanRecord = (params) => {
  return axios.get("/api/GetZjwjPlanRecord", params);
};

// 获取上传资料
export const GetZjwjPlanModel = (params) => {
  return axios.get("/api/GetZjwjPlanModel", params);
};
// 删除文件
export const DelZjwjPlanModel = (params) => {
  return axios.post("/api/DelZjwjPlanModel", params);
};

// 获取我的文档
export const GetZjwjMyFile = (params) => {
  return axios.get("/api/GetZjwjMyFile", params);
};

// 审核通过
export const ZjwjPlanAuditPass = (params) => {
  return axios.post("/api/ZjwjPlanAuditPass", params);
};

// 审核监控
export const ZjwjAuditList = (params) => {
  return axios.get("/api/ZjwjAuditList", params);
};

// 驳回
export const ZjwjPlanAuditNoPass = (params) => {
  return axios.post("/api/ZjwjPlanAuditNoPass", params);
};

// 添加碰撞检查
export const AddCrashCheck = (params) => {
  return axios.post("/api/AddCrashCheck", params);
};

// 删除碰撞检查
export const DelCrashCheck = (params) => {
  return axios.post("/api/DelCrashCheck", params);
};

// 获取碰撞检查
export const GetCrashCheck = (params) => {
  return axios.get("/api/GetCrashCheck", params);
};
// 添加颜色
export const AddModelColor = (params) => {
  return axios.post("/api/AddModelColor", params);
};
// 删除模型着色
export const DelModelColor = (params) => {
  return axios.post("/api/DelModelColor", params);
};
// 获取模型着色
export const GetModelColor = (params) => {
  return axios.post("/api/GetModelColor", params);
};
// office转pdf
export const Office2Pdf = (params) => {
  return axios.post("/api/Office2Pdf", params);
};

// 获取文档评审
export const GetFileAudit = (params) => {
  return axios.get("/api/GetFileAudit", params);
};
// 删除文档评审
export const DelFileAudit = (params) => {
  return axios.post("/api/DelFileAudit", params);
};
// 添加文档评审
export const AddFileAudit = (params) => {
  return axios.post("/api/AddFileAudit", params);
};
// 获取驳回信息
export const GetPlanAudit = (params) => {
  return axios.get("/api/GetPlanAudit", params);
};
//企管-项目报表
export const ProjectReport = (params) => {
  return axios.get("/api/ProjectReport", params);
};
// EnterpriseReport
export const EnterpriseReport = (params) => {
  return axios.get("/api/EnterpriseReport", params);
};

//获取计划时间限制
export const GetZjwjPlanDetailTime = (params) => {
  return axios.get("/api/GetZjwjPlanDetailTime", params);
};

// 会话列表
export const GetModelDiscuss = (params) => {
  return axios.get("/api/GetModelDiscuss", params);
};
// 发起会话
export const AddModelDiscuss = (params) => {
  return axios.post("/api/AddModelDiscuss", params);
};
// 获取工作面板
export const GetWorkPlane = (params) => {
  return axios.get("/api/GetWorkPlane", params);
};
// 初始化树节点
export const initWorkPlane = (params) => {
  return axios.post("/api/initWorkPlane", params);
};
// 获取视点列表

export const GetZjwjViewPoint = (params) => {
  return axios.get("/api/GetZjwjViewPoint", params);
};

// 添加会话内容
export const AddDiscussContent = (params) => {
  return axios.post("/api/AddDiscussContent", params);
};
// 获取会话内容列表
export const GetDiscussContent = (params) => {
  return axios.get("/api/GetDiscussContent", params);
};
// 查找工作面板模型
export const GetWorkPlanModel = (params) => {
  return axios.get("/api/GetWorkPlanModel", params);
};
//工作面板重命名
export const RenameWorkPlane = (params) => {
  return axios.post("/api/RenameWorkPlane", params);
};
// 确认验收
export const FinishDiscuss = (params) => {
  return axios.post("/api/FinishDiscuss", params);
};
// 计划发起审核
export const PlanStartAudit = (params) => {
  return axios.post("/api/PlanStartAudit", params);
};
// 计划提交审核
export const PlanSubmitAudit = (params) => {
  return axios.post("/api/PlanSubmitAudit", params);
};
// 获取计划审核
export const GetPlanSubmitAudit = (params) => {
  return axios.get("/api/GetPlanSubmitAudit", params);
};
//上传模型
export const ZjwjUploadModelFile = (params) => {
  return axios.post("/api/ZjwjUploadModelFile", params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
//上传未转换的模型
export const ZjwjUploadModelRvt = (params) => {
  return axios.post("/api/ZjwjUploadModelRvt", params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
//启用/禁用工作面板
export const WorkPlaneIsOpen = (params) => {
  return axios.post("/api/WorkPlaneIsOpen", params);
};
//获取项目下的所有计划
export const GetProjectPlan = (params) => {
  return axios.get("/api/GetProjectPlan", params);
};
//获取计划下上传过资料的人员
export const GetPlanUploader = (params) => {
  return axios.get("/api/GetPlanUploader", params);
};
//任务成果饼状图
export const TaskResultChart = (params) => {
  return axios.get("/api/TaskResultChart", params);
};
//获取计划下资料
export const GetPlanFiles = (params) => {
  return axios.get("/api/GetPlanFiles", params);
};
//计划资料下载
export const PlanFileDownLoad = (params) => {
  return axios.get("/api/PlanFileDownLoad", params);
};
//项目看板
export const ProjectDataV = (params) => {
  return axios.get("/api/ProjectDataV", params);
};
//删除计划
export const ZjwjDelPlan = (params) => {
  return axios.post("/api/ZjwjDelPlan", params);
};
//复制进度计划（中建五局）
export const ZjwjCopyPlan = (params) => {
  return axios.post("/api/ZjwjCopyPlan", params);
};
//获取项目编号
export const GetProjectNumber = (params) => {
  return axios.get("/api/GetProjectNumber", params);
};
//删除项目
export const DelProject = (params) => {
  return axios.post("/api/DelProject", params);
};
//企业导出人员模板
export const ExportPersonTemplate = (params) => {
  return axios.post("/api/ExportPersonTemplate", params);
};

// 删除模型会话
export const DelModelDiscuss = (params) => {
  return axios.post("/api/DelModelDiscuss", params);
};

// 修改模型会话
export const UpdateModelDiscuss = (params) => {
  return axios.post("/api/UpdateModelDiscuss", params);
};

// 添加文档审核流程
export const AddFileWorkFlow = (params) => {
  return axios.post("/api/AddFileWorkFlow", params);
};

// 获取文档审核流程
export const GetFileWorkFlow = (params) => {
  return axios.get("/api/GetFileWorkFlow", params);
};

// 查询单个文档审核流程

export const FindFileWorkFlow = (params) => {
  return axios.get("/api/FindFileWorkFlow", params);
};

// 更新单个文档审核流程
export const UpdateFileWorkFlow = (params) => {
  return axios.post("/api/UpdateFileWorkFlow", params);
};

// 拷贝文档审核流程
export const CopyFileWorkFlow = (params) => {
  return axios.post("/api/CopyFileWorkFlow", params);
};

// 删除文档审核流程
export const DelFileWorkFlow = (params) => {
  return axios.post("/api/DelFileWorkFlow", params);
};

// 我上传的资料
export const GetMyUploadFile = (params) => {
  return axios.get("/api/GetMyUploadFile", params);
};

// 文档批量处理
export const FileBatchDeal = (params) => {
  return axios.post("/api/FileBatchDeal", params);
};

// 获取我审核的资料
export const GetMyAuditFile = (params) => {
  return axios.get("/api/GetMyAuditFile", params);
};

// 文件批量处理
export const FileBatchAudit = (params) => {
  return axios.post("/api/FileBatchAudit", params);
};
// 获取驳回信息
export const FindBHMsg = (params) => {
  return axios.get("/api/FindBHMsg", params);
};

//导出查询节点
export const GetControlData = (params) => {
  return axios.get("api/GethelpdocZTree", params);
};
//导出添加节点
export const InsertzNode = (params) => {
  return axios.post("api/Addhelpdoc", params);
};
//导出编辑节点
export const UpdatezNode = (params) => {
  return axios.post("api/Edithelpdoc", params);
};
//导出删除节点
export const DeletezNode = (params) => {
  return axios.post("api/Delhelpoc", params);
};
//查询编辑详细
export const Findhelpdoc = (params) => {
  return axios.get("/api/Findhelpdoc", params);
};
// 流程模版
export const AddOrUpdateFormTemp = (params) => {
  return axios.post("/api/AddOrUpdateFormTemp", params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
export const GetFormTempList = (params) => {
  return axios.get("/api/GetFormTempList", params);
};
export const GetOneFormTemp = (params) => {
  return axios.get("/api/GetOneFormTemp", params);
};
export const DelOneFormTemp = (params) => {
  return axios.post("/api/DelOneFormTemp", params);
};
//登录发送短信验证码
export const shortproving = (params) => {
  return axios.post("/api/SendSMSAsync", params);
};
//注册
export const UserRegister = (params) => {
  return axios.post("/api/Register", params);
};
//忘记密码
export const Forgetpassword = (params) => {
  return axios.post("/api/ForgetPwd", params);
};

export const AddOrUpdateFormAuditFlow = (params) => {
  return axios.post("/api/AddOrUpdateFormAuditFlow", params);
};
export const GetFormAuditFlowList = (params) => {
  return axios.get("/api/GetFormAuditFlowList", params);
};
export const GetOneFormAuditFlow = (params) => {
  return axios.get("/api/GetOneFormAuditFlow", params);
};

export const DelFormAuditFlow = (params) => {
  return axios.post("/api/DelFormAuditFlow", params);
};

export const CopyFormAuditFlow = (params) => {
  return axios.post("/api/CopyFormAuditFlow", params);
};

export const GetFullFormTemp = (params) => {
  return axios.get("/api/GetFullFormTemp", params);
};
// 新版--申请进入企业、项目   获取申请记录
export const GetApplyRecord = (params) => {
  return axios.get("/api/GetApplyRecord", params);
};
// 获取公司组织架构和企业职位
export const GetCompanyDeptAndJob = (params) => {
  return axios.get("/api/GetCompanyDeptAndJob", params);
};
// 获取项目组织架构和职位
export const GetProjectDeptAndJob = (params) => {
  return axios.get("/api/GetProjectDeptAndJob", params);
};
// 申请加入企业
export const ApplyToJoinCompany = (params) => {
  return axios.post("/api/ApplyToJoinCompany", params);
};
export const SetUrge = (params) => {
  return axios.post("/api/SetUrge", params);
};
export const DelApply = (params) => {
  return axios.post("/api/DelApply", params);
};
// 申请进入项目
export const ApplyToJoinProject = (params) => {
  return axios.post("/api/ApplyToJoinProject", params);
};
// 消息通知
export const GetMessage = (params) => {
  return axios.get("/api/GetMessage", params);
};
export const HandleMsg = (params) => {
  return axios.post("/api/HandleMsg", params);
};
export const DelMsg = (params) => {
  return axios.post("/api/DelMsg", params);
};

export const UpdateFormApply = (params) => {
  return axios.post("/api/UpdateFormApply", params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const SubmitAudit = (params) => {
  return axios.post("/api/SubmitAudit", params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
export const DelRecord = (params) => {
  return axios.post("/api/DelRecord", params);
};
//验证帐号密码
export const Verifypassword = (params) => {
  return axios.post("/api/CheckPwd", params);
};
//更换手机号码
export const replaceIph = (params) => {
  return axios.post("/api/UpdatePhone", params);
};
//超管变更手机号码
export const changeIph = (params) => {
  return axios.post("/api/UpdatePhoneByAdmin", params);
};
//验证分享视点
export const VerityViewPoint = (params) => {
  return axios.get("/api/VerityViewPoint", params);
};
//获取分享视点列表
export const GetViewPointShare = (params) => {
  return axios.get("/api/GetViewPointShare", params);
};
//更新视点状态
export const UpdateViewPointShareState = (params) => {
  return axios.post("/api/UpdateViewPointShareState", params);
};
//删除视点分享
export const DelViewPointShare = (params) => {
  return axios.post("/api/DelViewPointShare", params);
};

export const GetUserByToken = (params) => {
  return axios.get("/api/GetUserByToken", params);
};

export const GetFormTask = (params) => {
  return axios.get("/api/GetFormTask", params);
};
export const GetPlanTask = (params) => {
  return axios.get("/api/GetPlanTask", params);
};
export const GetWorkOrderTask = (params) => {
  return axios.get("/api/GetWorkOrderTask", params);
};
export const GetWeiBoList = (params) => {
  return axios.get("/api/GetWeiBoList", params);
};
export const submitVisibleUser = (params) => {
  return axios.post("/api/submitVisibleUser", params);
};

//第三方平台登陆对接
//科尼云
export const KnyRegister = (params) => {
  return axios.post("/api/KnyRegister", params);
};

//协同6.0---------------------------------------------------------------
export const GetModelStateList = (params) => {
  return axios.get("/api/GetModelStateList", params);
};
export const AddFormApply = (params) => {
  return axios.post("/api/AddFormApply", params);
};
export const GetFormApply = (params) => {
  return axios.get("/api/GetFormApply", params);
};
export const PressFormApply = (params) => {
  return axios.post("/api/PressFormApply", params);
};
export const RecreateTemp = (params) => {
  return axios.post("/api/RecreateTemp", params);
};
export const GetFormAuditRecord = (params) => {
  return axios.get("/api/GetFormAuditRecord", params);
};
export const GetFormAuditFlow = (params) => {
  return axios.get("/api/GetFormAuditFlow", params);
};
export const FindFormApplyDetail = (params) => {
  return axios.get("/api/FindFormApplyDetail", params);
};
export const CancelFormApply = (params) => {
  return axios.post("/api/CancelFormApply", params);
};
export const DelFormApply = (params) => {
  return axios.post("/api/DelFormApply", params);
};
export const UpdateFormApplys = (params) => {
  return axios.post("/api/UpdateFormApply", params);
};
export const SubmitTurndown = (params) => {
  return axios.post("/api/SubmitTurndown", params);
};
export const AddFormComment = (params) => {
  return axios.post("/api/AddFormComment", params);
};
export const GetFormComment = (params) => {
  return axios.get("/api/GetFormComment", params);
};
export const DelFormComment = (params) => {
  return axios.post("/api/DelFormComment", params);
};
export const ProjectDataBoard = (params) => {
  return axios.get("/api/ProjectDataBoard", params);
};
export const GetXGFormApply = (params) => {
  return axios.get("/api/GetXGFormApply", params);
};
export const TopPlan = (params) => {
  return axios.post("/api/TopPlan", params);
};

// 进度展示
export const AddOrUpdateProgressShow = (params) => {
  return axios.post("/api/AddOrUpdateProgressShow", params);
};
export const DropProgressShow = (params) => {
  return axios.post("/api/DropProgressShow", params);
};
export const DelProgressShow = (params) => {
  return axios.post("/api/DelProgressShow", params);
};
export const GetProgressShow = (params) => {
  return axios.get("/api/GetProgressShow", params);
};

export const GetOneUploadFile = (params) => {
  return axios.get("/api/GetOneUploadFile", params);
};
export const transformfilemodel = (params) => {
  return axios.post("/api/transformfilemodel", params);
};
export const GetFileLabel = (params) => {
  return axios.get("/api/GetFileLabel", params);
};
export const ChangeFileLebalOrder = (params) => {
  return axios.post("/api/ChangeFileLebalOrder", params);
};
export const SetFileLabel = (params) => {
  return axios.post("/api/SetFileLabel", params);
};
export const DeleteFileLabel = (params) => {
  return axios.post("/api/DeleteFileLabel", params);
};
export const UpdateDataFile = (params) => {
  return axios.post("/api/UpdateDataFile", params);
};
export const setProgressShowState = (params) => {
  return axios.post("/api/setProgressShowState", params);
};
export const getProgressShowState = (params) => {
  return axios.get("/api/getProgressShowState", params);
};
export const delProgressShowState = (params) => {
  return axios.post("/api/DeleteProgressShowState", params);
};
export const AddRecentlyFile = (params) => {
  return axios.post("/api/AddRecentlyFile", params);
};
export const GetRecentlyFile = (params) => {
  return axios.post("/api/GetRecentlyFile", params);
};
//添加批注
export const AddComment = (params) => {
  return axios.post("/api/AddComment", params);
};
//获取批注
export const GetComment = (params) => {
  return axios.get("/api/GetComment", params);
};
//获取审图要点
export const GetCheckList = (params) => {
  return axios.get("/api/GetCheckList", params);
};
//获取树节点带文档
export const GetFileTreeWithFiles = (params) => {
  return axios.get("/api/GetFileTreeWithFiles", params);
};
//获取部门带人员
export const GetDeptWithUser2 = params => {
  return axios.get("/api/GetDeptWithUser2", params)
}
//修改批注状态 ChangeCommentState(int commentId, string state)
export const ChangeCommentState = params => {
  return axios.post("/api/ChangeCommentState", params)
}
//添加批注回复 AddCommentRecord(kte_commentrecord record)
export const AddCommentRecord = params => {
  return axios.post("/api/AddCommentRecord", params)
}
//获取批注回复 GetCommentRecord(int commentId)
export const GetCommentRecord = params => {
  return axios.get("/api/GetCommentRecord", params)
}
//删除批注 DelComment(int id)
export const DelComment = params => {
  return axios.post("/api/DelComment", params)
}
//#endregion